<template>
  <b-card :title="titleForm">
    <validation-observer ref="form">
      <b-form @submit.prevent>
        <b-row>
          <!-- Nome -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="nome"
              rules="required"
            >
              <b-form-group label="Nome da Moeda" label-for="v-nome">
                <b-form-input
                  id="v-nome"
                  v-model="form.nome"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Ex: Real, Dólar..."
                  data-cy="nome"
                  :disabled="
                    (!verificarPermissao('ROLE_FINAN_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                  "
                />
                <small data-cy="v-nome" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Descrição / Sigla -->
          <b-col cols="12">
            <validation-provider
              #default="{ errors }"
              name="descrição"
              rules="required"
            >
              <b-form-group label="Sigla (BRL, USD...)" label-for="v-description">
                <b-form-input
                  id="v-description"
                  v-model="form.descricao"
                  placeholder="Sigla"
                  :state="errors.length > 0 ? false : null"
                  data-cy="description"
                  :disabled="
                    (!verificarPermissao('ROLE_FINAN_ATUALIZAR') &&
                      !!form.id) ||
                    (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                  "
                />
                <small data-cy="v-description" class="text-danger">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- Ativo -->
          <b-col cols="12">
            <b-form-group label="Ativo">
              <b-form-checkbox
                v-model="form.ativo"
                switch
                :disabled="
                  (!verificarPermissao('ROLE_FINAN_ATUALIZAR') &&
                    !!form.id) ||
                  (!verificarPermissao('ROLE_FINAN_INSERIR') && !form.id)
                "
              />
            </b-form-group>
          </b-col>

          <!-- submit and reset -->
          <ButtonsFormVue
            :permission-insert="verificarPermissao('ROLE_FINAN_INSERIR')"
            :permission-edit="verificarPermissao('ROLE_FINAN_ATUALIZAR')"
            :disable-form="false"
            @save="save()"
            @cancel="cancel()"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormCheckbox
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { verificarPermissao } from '@/auth/utils'
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue'
import mixinsGlobal from '@/mixins'

export default {
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('moedaSettingsModule', {
      moeda: (state) => state.moeda
    })
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue
  },
  directives: {
    Ripple
  },
  data() {
    return {
      verificarPermissao,
      titleForm: 'Cadastro de Moedas',
      required,
      form: {
        id: null,
        nome: '',
        descricao: '',
        ativo: true
      }
    }
  },
  mounted() {
    this.form = JSON.parse(JSON.stringify(this.moeda))
  },
  methods: {
    cancel() {
      this.$emit('cancelar')
      this.cleanObjeto()
      this.$store.dispatch('moedaSettingsModule/resetMoeda')
    },
    save() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (this.form.id) {
            this.$store
              .dispatch('moedaSettingsModule/editMoeda', this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Editar',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Editar', 'Editado com sucesso!')
                this.$refs.form.reset()
                this.cancel()
              })
          } else {
            this.$store
              .dispatch('moedaSettingsModule/insertNewMoeda', this.form)
              .then((response) => {
                if (response.response) {
                  this.MensagemError(
                    'Falha ao Inserir',
                    response.response.data.error
                  )
                  return
                }
                this.showMessageSuccess('Salvo', 'Incluido com sucesso!')
                this.cleanObjeto()
                this.$refs.form.reset()
              })
          }
        }
      })
    },
    cleanObjeto() {
      this.form = {
        nome: '',
        descricao: '',
        ativo: true
      }
    }
  }
}
</script>
